"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2021],{

/***/ 96613:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "EI": function() { return /* binding */ parseExpireMs; },
/* harmony export */   "Jn": function() { return /* binding */ THIRTY_DAYS_MS; },
/* harmony export */   "SR": function() { return /* binding */ isExpiredWithinGracePeriod; },
/* harmony export */   "ku": function() { return /* binding */ resolveDeviceExpireTime; },
/* harmony export */   "l": function() { return /* binding */ buildDeviceUserPayload; },
/* harmony export */   "xC": function() { return /* binding */ isSubscriptionActive; }
/* harmony export */ });
/* unused harmony exports isDeviceActive, isExpiredPastGracePeriod, areAllDevicesExpiredPastGrace, isDeviceWithinGracePeriod, shouldShowExpiredMask, pickFirstActiveDevice */
/**
 * 解析 expire_time 为 UTC 毫秒时间戳。
 * ISO 8601 带 Z（如 2026-11-16T07:35:07.623Z）会被正确解析为绝对时刻，与用户本地时区无关。
 */ const parseExpireMs = (raw)=>{
    if (raw == null || raw === "") return NaN;
    const ms = new Date(raw).getTime();
    return Number.isFinite(ms) ? ms : NaN;
};
/** 订阅仍有效：无 expire_time 视为有效；否则 expire_time >= 当前时刻 */ const isSubscriptionActive = function(expireTime) {
    let now = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Date.now();
    const ms = parseExpireMs(expireTime);
    if (!Number.isFinite(ms)) return true;
    return ms >= now;
};
const isDeviceActive = (device)=>{
    return isSubscriptionActive(device === null || device === void 0 ? void 0 : device.expire_time);
};
const THIRTY_DAYS_MS = 30 * 24 * 60 * 60 * 1000;
/** 已过期且仍在 30 天宽限期内；恰好第 30 天仍符合，未过期或超过 30 天均不符合 */ const isExpiredWithinGracePeriod = function(expireTime) {
    let now = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Date.now(), graceMs = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : THIRTY_DAYS_MS;
    const ms = parseExpireMs(expireTime);
    if (!Number.isFinite(ms) || !Number.isFinite(now) || ms >= now) return false;
    return now - ms <= graceMs;
};
/** 已过期且超过宽限期（默认 30 天） */ const isExpiredPastGracePeriod = function(expireTime) {
    let now = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Date.now(), graceMs = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : THIRTY_DAYS_MS;
    const ms = parseExpireMs(expireTime);
    if (!Number.isFinite(ms)) return false;
    if (ms >= now) return false;
    return now - ms > graceMs;
};
/** 全部设备均已过期且超过宽限期 */ const areAllDevicesExpiredPastGrace = function(devices) {
    let now = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Date.now(), graceMs = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : THIRTY_DAYS_MS;
    const list = Array.isArray(devices) ? devices : [];
    if (!list.length) return false;
    return list.every((device)=>{
        return isExpiredPastGracePeriod(device === null || device === void 0 ? void 0 : device.expire_time, now, graceMs);
    });
};
/** 从侧栏设备项（数组或单条记录）解析 expire_time */ const resolveDeviceExpireTime = (item)=>{
    var ref, ref1, ref2;
    if (!item) return null;
    if (item.expire_time != null && item.expire_time !== "") return item.expire_time;
    if (Array.isArray(item) && ((ref = item[0]) === null || ref === void 0 ? void 0 : (ref1 = ref.DeviceUser) === null || ref1 === void 0 ? void 0 : ref1.expire_time)) return item[0].DeviceUser.expire_time;
    if (item === null || item === void 0 ? void 0 : (ref2 = item.DeviceUser) === null || ref2 === void 0 ? void 0 : ref2.expire_time) return item.DeviceUser.expire_time;
    return null;
};
/** 侧栏仍展示：未过期、无 expire_time、或过期未超过 graceDays（默认 30 天） */ const isDeviceWithinGracePeriod = function(expireTime) {
    let now = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Date.now(), graceMs = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : THIRTY_DAYS_MS;
    const ms = parseExpireMs(expireTime);
    if (!Number.isFinite(ms)) return true;
    if (ms >= now) return true;
    return now - ms <= graceMs;
};
/** Feature 详情页遮罩：已过期且在宽限期内（默认 30 天） */ const shouldShowExpiredMask = function(expireTime) {
    let now = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Date.now(), graceMs = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : THIRTY_DAYS_MS;
    return !isSubscriptionActive(expireTime, now) && isDeviceWithinGracePeriod(expireTime, now, graceMs);
};
/** 取第一个可选中设备：优先未过期(active)，其次宽限期(grace)；永不返回超 30 天失效 */ const pickFirstActiveDevice = (devices, platformType)=>{
    const list = Array.isArray(devices) ? devices : [];
    const scoped = platformType ? list.filter((item)=>{
        return (item === null || item === void 0 ? void 0 : item.platform_type) === platformType;
    }) : list;
    const now = Date.now();
    const selectable = scoped.filter((item)=>{
        const ms = parseExpireMs(item === null || item === void 0 ? void 0 : item.expire_time);
        if (!Number.isFinite(ms)) return true;
        if (ms >= now) return true;
        return now - ms <= THIRTY_DAYS_MS;
    });
    if (!selectable.length) return null;
    return selectable.find(isDeviceActive) || selectable[0] || null;
};
var ref, ref1, ref2;
const buildDeviceUserPayload = (device)=>{
    return {
        username: device.iCloud_username,
        password: device.iCloud_password,
        temporary: device.temporary,
        expire_time: device.expire_time,
        likeType: device.like_type,
        device_id: (device === null || device === void 0 ? void 0 : device.id) || (device === null || device === void 0 ? void 0 : device.device_id) || "",
        order_id: (ref1 = (ref = device === null || device === void 0 ? void 0 : device.order_id) !== null && ref !== void 0 ? ref : device === null || device === void 0 ? void 0 : device.orderId) !== null && ref1 !== void 0 ? ref1 : null,
        subscription_status: (ref2 = device === null || device === void 0 ? void 0 : device.subscription_status) !== null && ref2 !== void 0 ? ref2 : null
    };
};


/***/ }),

/***/ 38365:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "He": function() { return /* binding */ isSelectableDevice; },
/* harmony export */   "MA": function() { return /* binding */ resolveDeviceSubscriptionStatus; },
/* harmony export */   "Mi": function() { return /* binding */ resolveInitialEntry; },
/* harmony export */   "Xz": function() { return /* binding */ getDeviceNotSelectableMessage; },
/* harmony export */   "cw": function() { return /* binding */ isGraceDevice; },
/* harmony export */   "dv": function() { return /* binding */ validateDeviceSelection; },
/* harmony export */   "mJ": function() { return /* binding */ isDeviceVisibleInSidebar; },
/* harmony export */   "oT": function() { return /* binding */ pickPreferredSelectableDevice; },
/* harmony export */   "q6": function() { return /* binding */ shouldEnterExpiredPurchasePage; },
/* harmony export */   "qq": function() { return /* binding */ SUBSCRIPTION_STATUS; },
/* harmony export */   "w4": function() { return /* binding */ resolveDeviceOrderId; }
/* harmony export */ });
/* unused harmony exports normalizeSubscriptionStatus, resolveSubscriptionStatus, isSelectableSubscriptionStatus, isLapsedDevice, isNoneDevice, areAllDevicesLapsed, areAllDevicesNonSelectable */
/* harmony import */ var src_utils_subscriptionExpire__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96613);

/** 设备订阅状态机（与后端 user-device.subscription_status 对齐） */ const SUBSCRIPTION_STATUS = Object.freeze({
    /** 未过期 */ ACTIVE: "active",
    /** 已过期且 ≤30 天（含第 30 天，宽限期，仍可选中） */ GRACE: "grace",
    /** 已过期且 >30 天（失效，禁止选中） */ LAPSED: "lapsed",
    /**
   * 特殊态：无已支付订单，或 expire_time 为空/异常。
   * ≠ lapsed：不进「全员超 30 天」独立续费页；也不可选中。
   */ NONE: "none"
});
const STATUS_SET = new Set(Object.values(SUBSCRIPTION_STATUS));
const normalizeSubscriptionStatus = (raw)=>{
    if (raw == null || raw === "") return null;
    const status = String(raw).toLowerCase();
    return STATUS_SET.has(status) ? status : null;
};
/**
 * 由 expire_time 本地兜底（接口未回 subscription_status 时用）。
 * 无有效 expire_time → active（兼容历史无到期字段仍可进 dashboard）。
 * 服务端显式 none 时走 subscription_status 字段，不走本函数。
 */ const resolveSubscriptionStatus = function(expireTime) {
    let now = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Date.now(), graceMs = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : src_utils_subscriptionExpire__WEBPACK_IMPORTED_MODULE_0__/* .THIRTY_DAYS_MS */ .Jn;
    const ms = (0,src_utils_subscriptionExpire__WEBPACK_IMPORTED_MODULE_0__/* .parseExpireMs */ .EI)(expireTime);
    if (!Number.isFinite(ms)) return SUBSCRIPTION_STATUS.ACTIVE;
    if (ms >= now) return SUBSCRIPTION_STATUS.ACTIVE;
    if (now - ms <= graceMs) return SUBSCRIPTION_STATUS.GRACE;
    return SUBSCRIPTION_STATUS.LAPSED;
};
/**
 * 优先用设备/DeviceUser 上的 subscription_status；否则用 expire_time 兜底。
 */ const resolveDeviceSubscriptionStatus = function(device) {
    let now = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Date.now(), graceMs = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : src_utils_subscriptionExpire__WEBPACK_IMPORTED_MODULE_0__/* .THIRTY_DAYS_MS */ .Jn;
    const fromApi = normalizeSubscriptionStatus(device === null || device === void 0 ? void 0 : device.subscription_status);
    if (fromApi) return fromApi;
    var ref;
    return resolveSubscriptionStatus((ref = (0,src_utils_subscriptionExpire__WEBPACK_IMPORTED_MODULE_0__/* .resolveDeviceExpireTime */ .ku)(device)) !== null && ref !== void 0 ? ref : device === null || device === void 0 ? void 0 : device.expire_time, now, graceMs);
};
/** active / grace 可选中；lapsed / none 禁止成为当前选中 */ const isSelectableSubscriptionStatus = (status)=>status === SUBSCRIPTION_STATUS.ACTIVE || status === SUBSCRIPTION_STATUS.GRACE;
const isSelectableDevice = function(device) {
    let now = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Date.now(), graceMs = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : src_utils_subscriptionExpire__WEBPACK_IMPORTED_MODULE_0__/* .THIRTY_DAYS_MS */ .Jn;
    if (!device) return false;
    return isSelectableSubscriptionStatus(resolveDeviceSubscriptionStatus(device, now, graceMs));
};
const isLapsedDevice = function(device) {
    let now = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Date.now(), graceMs = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : src_utils_subscriptionExpire__WEBPACK_IMPORTED_MODULE_0__/* .THIRTY_DAYS_MS */ .Jn;
    return resolveDeviceSubscriptionStatus(device, now, graceMs) === SUBSCRIPTION_STATUS.LAPSED;
};
const isGraceDevice = function(device) {
    let now = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Date.now(), graceMs = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : src_utils_subscriptionExpire__WEBPACK_IMPORTED_MODULE_0__/* .THIRTY_DAYS_MS */ .Jn;
    return resolveDeviceSubscriptionStatus(device, now, graceMs) === SUBSCRIPTION_STATUS.GRACE;
};
const isNoneDevice = function(device) {
    let now = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Date.now(), graceMs = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : THIRTY_DAYS_MS;
    return resolveDeviceSubscriptionStatus(device, now, graceMs) === SUBSCRIPTION_STATUS.NONE;
};
/**
 * 侧栏设备卡片是否展示：
 * - active / grace：展示
 * - none：展示（特殊：无有效已付单，但仍是绑定记录）
 * - lapsed：隐藏
 */ const isDeviceVisibleInSidebar = function(device) {
    let now = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Date.now(), graceMs = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : src_utils_subscriptionExpire__WEBPACK_IMPORTED_MODULE_0__/* .THIRTY_DAYS_MS */ .Jn;
    if (!device) return false;
    return resolveDeviceSubscriptionStatus(device, now, graceMs) !== SUBSCRIPTION_STATUS.LAPSED;
};
/**
 * 设备关联已支付订单 ID（后端 user-device.order_id）。
 * @returns {string|number|null}
 */ const resolveDeviceOrderId = (device)=>{
    var ref, ref1;
    if (!device) return null;
    var _order_id, ref2, ref3;
    const id = (ref3 = (ref2 = (_order_id = device.order_id) !== null && _order_id !== void 0 ? _order_id : device.orderId) !== null && ref2 !== void 0 ? ref2 : device === null || device === void 0 ? void 0 : (ref = device.Order) === null || ref === void 0 ? void 0 : ref.id) !== null && ref3 !== void 0 ? ref3 : device === null || device === void 0 ? void 0 : (ref1 = device.order) === null || ref1 === void 0 ? void 0 : ref1.id;
    if (id == null || id === "") return null;
    return id;
};
/**
 * 初始化/恢复选中：优先 active，其次 grace；永不返回 lapsed/none。
 * @param {Array} devices
 * @param {string} [platformType]
 */ const pickPreferredSelectableDevice = (devices, platformType)=>{
    const list = Array.isArray(devices) ? devices : [];
    const scoped = platformType ? list.filter((item)=>{
        return (item === null || item === void 0 ? void 0 : item.platform_type) === platformType;
    }) : list;
    const selectable = scoped.filter((item)=>isSelectableDevice(item));
    if (!selectable.length) return null;
    const active = selectable.find((item)=>resolveDeviceSubscriptionStatus(item) === SUBSCRIPTION_STATUS.ACTIVE);
    return active || selectable[0] || null;
};
/**
 * 选中校验：仅 active/grace 可选。
 * @returns {{ ok: boolean, status: string, reason?: string }}
 */ const validateDeviceSelection = function(device) {
    let now = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Date.now();
    if (!device || typeof device === "object" && !Object.keys(device).length) {
        return {
            ok: true,
            status: SUBSCRIPTION_STATUS.NONE
        };
    }
    const status = resolveDeviceSubscriptionStatus(device, now);
    if (!isSelectableSubscriptionStatus(status)) {
        return {
            ok: false,
            status,
            reason: status === SUBSCRIPTION_STATUS.LAPSED ? "lapsed_device_not_selectable" : "device_not_selectable"
        };
    }
    return {
        ok: true,
        status
    };
};
/** 侧栏不可选设备的英文提示（none ≠ 过期） */ const getDeviceNotSelectableMessage = function(device) {
    let now = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Date.now();
    const status = resolveDeviceSubscriptionStatus(device, now);
    if (status === SUBSCRIPTION_STATUS.NONE) {
        return "This package has no active subscription and cannot be selected.";
    }
    if (status === SUBSCRIPTION_STATUS.LAPSED) {
        return "This package subscription has expired and cannot be selected.";
    }
    return "This package cannot be selected.";
};
/**
 * 是否「全部设备都是 lapsed」。
 * none 不算 lapsed（有 none 混在时为 false）。
 * 只信 subscription_status（无字段时才 expire_time 兜底）。
 */ const areAllDevicesLapsed = function(devices) {
    let now = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Date.now(), graceMs = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : src_utils_subscriptionExpire__WEBPACK_IMPORTED_MODULE_0__/* .THIRTY_DAYS_MS */ .Jn;
    const list = Array.isArray(devices) ? devices : [];
    if (!list.length) return false;
    return list.every((device)=>isLapsedDevice(device, now, graceMs));
};
/** 无任何可选中设备（全是 lapsed / none） */ const areAllDevicesNonSelectable = function(devices) {
    let now = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Date.now(), graceMs = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : THIRTY_DAYS_MS;
    const list = Array.isArray(devices) ? devices : [];
    if (!list.length) return false;
    return list.every((device)=>!isSelectableDevice(device, now, graceMs));
};
/**
 * 独立续费页入口（替换旧「全设备过期超 30 天 + 无未绑单」本地推算）：
 * - 设备非空且全部 subscription_status === lapsed
 * - 且 not-bind-order 无有效未绑单
 *
 * none 不进此页。
 */ const shouldEnterExpiredPurchasePage = function() {
    let { devices =[] , validUnboundOrders =[]  } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const list = Array.isArray(devices) ? devices : [];
    const unbound = Array.isArray(validUnboundOrders) ? validUnboundOrders : [];
    return list.length > 0 && areAllDevicesLapsed(list) && unbound.length === 0;
};
/**
 * 登录/进站：active/grace 设备 > 未绑单 > 空态
 * 「全部过期超 30 天」的判定已上移到 userEntryGate（后端状态优先），这里不再参与。
 * 永不选中 lapsed/none。
 * @returns {{ type: 'device'|'unbound'|'empty', device: object|null }}
 */ const resolveInitialEntry = function() {
    let { devices =[] , validUnboundOrders =[] , preferredMode =null , preferredDevice =null  } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const list = Array.isArray(devices) ? devices : [];
    const unbound = Array.isArray(validUnboundOrders) ? validUnboundOrders : [];
    if (preferredDevice && isSelectableDevice(preferredDevice)) {
        return {
            type: "device",
            device: preferredDevice
        };
    }
    const preferred = pickPreferredSelectableDevice(list, preferredMode) || pickPreferredSelectableDevice(list);
    if (preferred) {
        return {
            type: "device",
            device: preferred
        };
    }
    if (unbound.length > 0) {
        return {
            type: "unbound",
            device: null
        };
    }
    return {
        type: "empty",
        device: null
    };
};


/***/ }),

/***/ 35064:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ix": function() { return /* binding */ getUserDeviceList; },
/* harmony export */   "qI": function() { return /* binding */ isValidUserDeviceListResponse; }
/* harmony export */ });
/* unused harmony export readCachedUserDeviceList */
/* harmony import */ var src_api_login__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(68980);

let userDeviceRequest = null;
let userDeviceRequestToken = null;
const readAccessToken = ()=>{
    try {
        return  false ? 0 : localStorage.getItem("accessToken") || "";
    } catch (e) {
        return "";
    }
};
/** 只有成功且确实返回数组的响应，才代表有效设备包列表。 */ const isValidUserDeviceListResponse = (response)=>{
    const code = response === null || response === void 0 ? void 0 : response.code;
    return Boolean(response && (code == null || code === "" || [
        0,
        200
    ].includes(Number(code))) && Array.isArray(response.data));
};
const readCachedUserDeviceList = ()=>{
    if (false) {}
    try {
        const cached = JSON.parse(localStorage.getItem("allDeviceUser") || "null");
        return Array.isArray(cached) ? cached : null;
    } catch (e) {
        return null;
    }
};
const writeCachedUserDeviceList = (devices)=>{
    if ( false || !Array.isArray(devices)) return;
    try {
        localStorage.setItem("allDeviceUser", JSON.stringify(devices));
    } catch (e) {
    // Keep the API response usable when browser storage is unavailable.
    }
};
/** Reuse the auth bootstrap's device list across dashboard consumers. */ const getUserDeviceList = function() {
    let { forceRefresh =false , requestConfig ={}  } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const token = readAccessToken();
    if (userDeviceRequest && userDeviceRequestToken === token) return userDeviceRequest;
    if (!forceRefresh) {
        const cached = readCachedUserDeviceList();
        if (cached !== null) return Promise.resolve({
            code: 0,
            data: cached
        });
    }
    const request = (0,src_api_login__WEBPACK_IMPORTED_MODULE_0__.getAllUserDevice)({}, requestConfig).then((response)=>{
        if (token === readAccessToken() && isValidUserDeviceListResponse(response)) {
            writeCachedUserDeviceList(response.data);
        }
        return response;
    }).finally(()=>{
        if (userDeviceRequest === request) {
            userDeviceRequest = null;
            userDeviceRequestToken = null;
        }
    });
    userDeviceRequest = request;
    userDeviceRequestToken = token;
    return request;
};


/***/ }),

/***/ 1128:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ji": function() { return /* binding */ resolveUserEntry; },
/* harmony export */   "Kx": function() { return /* binding */ clearUserEntryFlags; },
/* harmony export */   "Tv": function() { return /* binding */ USER_ENTRY; },
/* harmony export */   "lf": function() { return /* binding */ loadUserEntryFlags; }
/* harmony export */ });
/* unused harmony export readUserEntryFlags */
/* harmony import */ var src_api_login__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(68980);
/* harmony import */ var src_utils_subscriptionStatus__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(38365);


/**
 * 进站入口判定。
 * 优先级固定（后端状态优先，本地推算仅作降级）：
 * 1. isBuy === false                    → 购买
 * 2. isBuy && shouldShowExpiredPage     → 过期超 30 天页
 * 3. 其余                               → 沿用设备 / 未绑单 / 绑定向导流程
 */ const USER_ENTRY = Object.freeze({
    BUY: "buy",
    EXPIRED: "expired",
    CONTINUE: "continue"
});
const readBoolean = (value)=>typeof value === "boolean" ? value : null;
let flagsCache = null;
let flagsLoading = null;
let flagsGeneration = 0;
/**
 * 读取 isBuy / shouldShowExpiredPage。
 * - isBuy：是否有过付费（订单或设备记录）
 * - shouldShowExpiredPage：由 /tsafely-order/valid 的 valid 取反（最新一笔已支付订单已过期超 30 天）
 * 任一请求失败时对应字段为 null，调用方回退到本地推算，避免把老用户误踢去购买页。
 * @returns {Promise<{ isBuy: boolean|null, shouldShowExpiredPage: boolean|null }>}
 */ const loadUserEntryFlags = async function() {
    let { forceRefresh =false  } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    if (!forceRefresh && flagsCache) return flagsCache;
    if (flagsLoading) return flagsLoading;
    const generation = flagsGeneration;
    const request = Promise.all([
        (0,src_api_login__WEBPACK_IMPORTED_MODULE_0__.getUserIsBuy)().catch(()=>null),
        (0,src_api_login__WEBPACK_IMPORTED_MODULE_0__.getUserHasValidOrder)().catch(()=>null)
    ]).then((param)=>{
        let [buyRes, validRes] = param;
        var ref, ref1;
        const hasValidOrder = readBoolean(validRes === null || validRes === void 0 ? void 0 : (ref = validRes.data) === null || ref === void 0 ? void 0 : ref.valid);
        const flags = {
            isBuy: readBoolean(buyRes === null || buyRes === void 0 ? void 0 : (ref1 = buyRes.data) === null || ref1 === void 0 ? void 0 : ref1.isBuy),
            shouldShowExpiredPage: hasValidOrder === null ? null : !hasValidOrder
        };
        if (generation === flagsGeneration) flagsCache = flags;
        return flags;
    }).finally(()=>{
        if (flagsLoading === request) flagsLoading = null;
    });
    flagsLoading = request;
    return request;
};
const readUserEntryFlags = ()=>flagsCache;
const clearUserEntryFlags = ()=>{
    flagsGeneration += 1;
    flagsCache = null;
    flagsLoading = null;
};
/**
 * 按固定优先级给出入口结论；后端状态拿不到时才用 devices / 未绑单本地推算。
 * @param {Object} params
 * @param {{ isBuy: boolean|null, shouldShowExpiredPage: boolean|null }} [params.flags]
 * @param {Array} [params.devices]
 * @param {Array} [params.validUnboundOrders]
 * @returns {'buy'|'expired'|'continue'}
 */ const resolveUserEntry = function() {
    let { flags , devices =[] , validUnboundOrders =[]  } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var ref;
    const isBuy = (ref = flags === null || flags === void 0 ? void 0 : flags.isBuy) !== null && ref !== void 0 ? ref : null;
    var ref1;
    const shouldShowExpiredPage = (ref1 = flags === null || flags === void 0 ? void 0 : flags.shouldShowExpiredPage) !== null && ref1 !== void 0 ? ref1 : null;
    if (isBuy === false) return USER_ENTRY.BUY;
    if (isBuy === true && shouldShowExpiredPage === true) return USER_ENTRY.EXPIRED;
    // 降级：后端状态缺失时（例如接口未上线/请求失败）沿用旧的本地推算
    if (isBuy === null || shouldShowExpiredPage === null) {
        if ((0,src_utils_subscriptionStatus__WEBPACK_IMPORTED_MODULE_1__/* .shouldEnterExpiredPurchasePage */ .q6)({
            devices,
            validUnboundOrders
        })) return USER_ENTRY.EXPIRED;
    }
    return USER_ENTRY.CONTINUE;
};


/***/ })

}]);